import type { FC } from "react";

import { displayBrazilPhone, formatBrazilPhone } from "@recobra/schemas/client";
import { Field, FieldError, FieldLabel } from "@recobra/ui/field";
import { Input } from "@recobra/ui/input";

import { getErrorMessage, useFieldContext } from "./context";

export const PhoneField: FC<{ label: string; id?: string }> = ({ label, id }) => {
  const field = useFieldContext<string | undefined>();
  const errorMessage = getErrorMessage(field.state.meta.errors[0]);

  return (
    <Field data-invalid={errorMessage ? "true" : undefined} className="min-w-0">
      <FieldLabel htmlFor={id}>{label}</FieldLabel>
      <Input
        id={id}
        value={displayBrazilPhone(field.state.value) ?? ""}
        onChange={(e) => {
          const next = formatBrazilPhone(e.target.value);
          field.handleChange(next || undefined);
        }}
        onBlur={field.handleBlur}
        inputMode="tel"
        maxLength={20}
        aria-invalid={Boolean(errorMessage)}
        autoComplete="tel"
      />
      {errorMessage ? <FieldError>{errorMessage}</FieldError> : null}
    </Field>
  );
};
